export default {
    search: 'Search',
    tooltip: {
        columnMenu: 'Customize table',
        resetFilters: 'Reset filters',
        downloadExcel: 'Excel download'
    }
}
